import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw9411Api, QueryRequest, QueryResponse } from '../../../services/pw9411Api';

export interface PW9411QueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface PW9411QueryActions {
  runQuery: (req: QueryRequest) => Promise<void>;
  reset: () => void;
}

export function usePW9411Query(): PW9411QueryState & PW9411QueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (req: QueryRequest) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw9411Api.query(req);
      if (resp.records && resp.records.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(resp);   // keep employee info even if no records
        setNoData(true);
        message.info('查無符合條件的出勤記錄');
      }
      setQueried(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { status?: number; data?: { error?: string } } };
      if (axiosErr.response?.status === 400) {
        message.error(axiosErr.response.data?.error || '查詢條件錯誤');
      } else {
        message.error('查詢失敗，請稍後再試');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
